import { Directive } from '@angular/core';
import { ShowOnEnterDirective } from './show-on-enter.directive';

@Directive({
  selector: '[showdown]',
  standalone: true,
})
export class ShowdownDirective extends ShowOnEnterDirective {
  protected override readonly direction = 'down';
}
